const labels = {
    today: "Today",
    yesterday: "Yesterday",
    previous7Days: "Previous 7 Days",
    previous30Days: "Previous 30 Days",
    older: "Older",
} as const
export const dateBuckets = Object.fromEntries(
    Object.entries(labels).map(([key, label]) => [key, { key, label }])
) as {
    [K in keyof typeof labels]: { key: K; label: (typeof labels)[K] }
}
export type DateBucket = (typeof dateBuckets)[keyof typeof dateBuckets]
export const dateBucketList = Object.values(dateBuckets)

const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate())

export const getDateBucket = (date: Date, now = new Date()): DateBucket => {
    const daysAgo = Math.floor(
        (startOfDay(now).getTime() - startOfDay(date).getTime()) / (1000 * 60 * 60 * 24)
    )
    if (daysAgo <= 0) return dateBuckets.today
    if (daysAgo === 1) return dateBuckets.yesterday
    if (daysAgo <= 7) return dateBuckets.previous7Days
    if (daysAgo <= 30) return dateBuckets.previous30Days
    return dateBuckets.older
}

export const groupByDateBucket = <T>(
    items: T[],
    getDate: (item: T) => Date,
    now = new Date()
): { bucket: DateBucket; items: T[] }[] => {
    const grouped = new Map<DateBucket, T[]>()

    for (const item of items) {
        const bucket = getDateBucket(getDate(item), now)
        grouped.set(bucket, [...(grouped.get(bucket) ?? []), item])
    }

    return dateBucketList
        .filter((bucket) => grouped.has(bucket))
        .map((bucket) => ({
            bucket,
            items: grouped.get(bucket)!,
        }))
}
